import { Box, SvgIcon, Tooltip, Typography } from '@mui/material';
import { Select } from '@/shared/ui';
import { WebLinkType } from '../../model/types';
import { WEB_LINKS_DESCRIPTIONS_MAP, WEB_LINKS_LABELS_MAP } from './constants';

const ITEMS: { value: WebLinkType; label: string }[] = Object.values(
  WebLinkType,
).map((type) => ({
  value: type,
  label: WEB_LINKS_LABELS_MAP[type],
}));

interface Props {
  error?: boolean;
  value: WebLinkType | '';
  onBlur: () => void;
  onChange: (value: WebLinkType) => void;
}

export function WebLinkTypeSelect({ error, value, onChange, onBlur }: Props) {
  const handleChange = (v: WebLinkType | '') => {
    if (v === '') {
      return;
    }
    onChange(v);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: 200,
        flexShrink: 0,
      }}
    >
      <Select<WebLinkType | ''>
        label="Type"
        error={error}
        value={value}
        options={ITEMS}
        onChange={handleChange}
        onBlur={onBlur}
      />
      <Tooltip
        placement="bottom-end"
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: '#343844',
            },
          },
        }}
        title={
          <Box>
            {Object.keys(WebLinkType).map((type) => {
              return (
                <Typography
                  key={type}
                  component="p"
                  variant="modalContent"
                  sx={{
                    lineHeight: '1.125rem',
                    color: 'white',
                    fontWeight: 400,
                  }}
                >
                  <b>{WEB_LINKS_LABELS_MAP[type as WebLinkType]}</b> -{' '}
                  {WEB_LINKS_DESCRIPTIONS_MAP[type as WebLinkType]}
                </Typography>
              );
            })}
          </Box>
        }
      >
        <SvgIcon>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="#7E828F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </SvgIcon>
      </Tooltip>
    </Box>
  );
}
